import React from 'react'
import PropTypes from 'prop-types'
import StringUtil from '@leverege/string-util'
import { Dialog } from '@leverege/ui-elements'
import { Validate } from '~/utils'

import { LabelGroup, FormValidator, Flex } from '~/views'

export default class CreateContactDialog extends React.Component {

  static contextTypes = {
    api : PropTypes.object
  }

  static propTypes = {
    onCreate : PropTypes.func,
    onHide : PropTypes.func,
    edit : PropTypes.object,
  }

  constructor( props ) {
    super( props )
    const edit = props.edit || {}
    this.state = { name : edit.name || '', 
                   email : edit.email || '', 
                   phone : edit.phone || '',
                   loading : true,
                   error : null }

    this.validator = FormValidator.create( this, 
      {
        name : {
          validator : Validate.notNullOrEmpty
        },
        email : {
          validator( v ) { return Validate.email( v, true ) }
        },
        phone : {
          validator( v ) { return Validate.phone( v, true ) }
        }
      }, 
      {
        onSubmit : this.onCreate,
        onSubmitValidator( state ) {
          let { email, phone } = state
          phone = StringUtil.nullOrTrim( phone )
          email = StringUtil.nullOrTrim( email )
          if ( phone == null && email == null ) {
            return { errors : [ 'phone', 'email' ] }
          }
          return null
        }
      } )
  }

  onCreate = ( ) => {
    let { name, email, phone } = this.state
    const { edit } = this.props

    name = StringUtil.nullOrTrim( name )
    phone = StringUtil.nullOrTrim( phone )
    email = StringUtil.nullOrTrim( email )

    const contact = { email, name, phone }
    if ( edit && edit.id ) {
      contact.id = edit.id
    }
    if ( name != null && ( phone != null || email != null ) ) {
      this.props.onCreate( contact )
    }
  }

  onSubmit = ( evt ) => {
    this.validator.onSubmit( evt.sourceEvent )
  }

  render() {
    const { name, email, phone } = this.state
    const { onCreate, onHide, edit, show, ...rest } = this.props

    const cOrU = edit && edit.id != null ? 'Update' : 'Create'

    return (
      <Dialog.Question
        title={`${cOrU} Contact`}
        show={show}
        okay={cOrU}
        cancel="Cancel"
        onOkay={this.onSubmit}
        onCancel={onHide}
        onClose={onHide}
        {...rest}>
        <Flex variant="vSpace" align="stretch" direction="column">
          <LabelGroup>
            <label style={{ width : '6em' }}>Name</label>
            <input type="text"
              name="name"
              autoFocus
              className={this.validator.classnames( 'name' )} 
              placeholder="Name..."
              value={name}
              onChange={this.validator.onInputChange} />
          </LabelGroup>
          <LabelGroup>
            <label style={{ width : '6em' }}>Email</label>
            <input type="text"
              name="email"
              className={this.validator.classnames( 'email' )} 
              placeholder="Email..."
              value={email}
              onChange={this.validator.onInputChange} />
          </LabelGroup>
          <LabelGroup>
            <label style={{ width : '6em' }}>Phone</label>
            <input type="text"
              name="phone"
              className={this.validator.classnames( 'phone' )} 
              placeholder="Phone number for sms notifications..."
              value={phone}
              onChange={this.validator.onInputChange} />
          </LabelGroup>
        </Flex>
      </Dialog.Question>
    )
  }
}
